import { render, staticRenderFns } from "./blueCard.vue?vue&type=template&id=e8f96564&scoped=true&"
import script from "./blueCard.vue?vue&type=script&lang=js&"
export * from "./blueCard.vue?vue&type=script&lang=js&"
import style0 from "./blueCard.vue?vue&type=style&index=0&id=e8f96564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f96564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8f96564')) {
      api.createRecord('e8f96564', component.options)
    } else {
      api.reload('e8f96564', component.options)
    }
    module.hot.accept("./blueCard.vue?vue&type=template&id=e8f96564&scoped=true&", function () {
      api.rerender('e8f96564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/blueCard.vue"
export default component.exports